var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFullstory = function SvgFullstory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Fullstory",
    style: {
      display: "block"
    },
    viewBox: "0 0 141 77"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M138 74.5H93l-4-1-9-5-3.5-3.5L70 52.5 65.5 63 56 71.5l-8 3H2L1.5 64l46.5-.5v-1l-12-7-26-14L8.5 39l5.5-8.5 22 13 18 10 1-1L31.5 13l10-5L64 47.5 64.5 2 75 1.5l.5 45.5h1L100 7.5l8 5 .5 2.5-23 38 1 1L126 30.5l5.5 8.5-1.5 2.5L104.5 56l-13 7v.5H138Z"
  })));
};
export default SvgFullstory;